export default "__VITE_ASSET__DGQ9$Ycq__";